export default {
  meta: {
    title: '开放页面-场地清单'
  }
};
